import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AutoCompleteDataSourceEnum } from 'src/app/shared/components/modals/auto-complete-modal/enums/auto-complete-data-source.enum';
import { AutoCompleteModalComponent } from '../../modals/auto-complete-modal/auto-complete-modal.component';

export interface IAPISuburb {
  txt: string;
  idx: number;
}

@Component({
  selector: 'app-suburb-selector-modal-input',
  templateUrl: './suburb-selector-modal-input.component.html',
  styleUrls: ['./suburb-selector-modal-input.component.scss'],
})
export class SuburbSelectorModalInputComponent {
  // Set to true if its a required field
  @Input() isRequired = false;

  // Set to true for input styling. Mostly used with mable-input
  @Input() asInput = false;

  // If you want to set the value of the selected record as field value.
  @Input() originalForm = false;

  // Field key of returned objects that is displayed to the user.
  @Input() displayField = 'suburb';

  // Pre selected value
  @Input() suburb: string;

  // Title to display in appbar
  @Input() title: string;

  // Emits selected value. Could be a single property or the whole object(original).
  @Output() updated = new EventEmitter<any>();

  constructor(public modalController: ModalController) {}

  /**
   *
   * @param event - event detail property contains the search text for suburb
   */
  async showSuburbModel(event?: CustomEvent) {
    const searchString = event ? event.detail.data : '';
    const modal = await this.modalController.create({
      component: AutoCompleteModalComponent,
      componentProps: {
        dataSource: AutoCompleteDataSourceEnum.SUBURB,
        displayField: 'address',
        searchString,
        title: this.title,
      },
      cssClass: 'fullpage-modal',
    });

    // https://github.com/ionic-team/ionic-framework/issues/26872
    modal.shadowRoot.querySelector('.modal-wrapper').removeAttribute('aria-modal');

    modal.onDidDismiss().then((searchFilter) => {
      if (searchFilter.data) {
        if (this.originalForm) {
          this.updated.emit(searchFilter.data);
        } else {
          this.updated.emit(<IAPISuburb>{
            txt: searchFilter.data[this.displayField],
            idx: searchFilter.data.post_code_geo_id,
          });
        }
      }
    });
    return await modal.present();
  }
}
